export const PAYMENTS_INFO_POPUP_TYPE = {
    weekly: 1,
    daily: 2
};
